import React from 'react';
import { Box } from '@mui/material';
import HeroSection from '../components/home/HeroSection';
import FeaturesSection from '../components/home/FeaturesSection';
import CTASection from '../components/home/CTASection';
import CodeExamplesSection from '../components/home/CodeExamplesSection';

const Home: React.FC = () => {
  return (
    <Box>
      <HeroSection />
      <FeaturesSection />
      <CTASection />
      <CodeExamplesSection />
    </Box>
  );
};

export default Home;
